export default __webpack_public_path__ + "static/media/right-arrow-empty.30718127.svg";